<template>
    <b-overlay :show="showoverlay" rounded="sm" class='demolistwrap'>
        <div class="card mt-0 border-0 bg-wash no-shadow demolistwrap2">

            <div class="card-header px-0 bg-transparent border-0">
            
                <div class="row no-margin" >

                    <div class="col-md-12 px-0">
                        <div class="d-inline-block trz_fields trz-custom-dropdown mb-1 trz_people_btn">
                            <div class="pl-0 company-employee-count" style="height: 31px; position: unset;"><span
                                    class="text-center px-2 border border-right-0 d-inline-block h-100 employee-count-icon"><b-icon
                                        class="" icon="people-fill"></b-icon></span><span
                                    class="text-center px-2 border d-inline-block h-100 employee-count-number"
                                    style="min-width: 51px;">{{ people }}</span></div>
                        </div>
                    </div>
                    <div class="col-sm-6 pl-0">
                        
                        <div class="align-self-center custom-search pr-0 mt-2" style="max-width: 480px;">
                            <b-input-group>
                                <b-input-group-prepend is-text>
                                    <b-icon icon="search"></b-icon>
                                </b-input-group-prepend>
                                <b-form-input type="search" placeholder="Search" v-model="search"
                                    @input="resetPagination()"></b-form-input>
                            </b-input-group>
                        </div>
                        
                    </div>
                    <div class="col-sm-6 pr-0 trz_ppl_wrapper"> 
                        <div class="col-12 text-right pr-0 trz_ppl_wrapper_2 mt-2">
                            <b-button id="filter_button"
                            class="employee-filter-btn mb-1 custom-secodary-btn" v-b-toggle.sidebar_right> <b-icon
                                class="ml-3" icon="funnel-fill"></b-icon>Filter
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-body px-0 container">
            
                <div class="employee-table-wrapper"
                    :class="[{ 'no-overflow': paginatedData.length < 8}, tableStickyHeight]">

                    <table class="employee-list-table table-overflow table-sticky ess-custom-table document-table tax-documents table-list fund_list_table">

                        <thead>
                            <tr class="table-head ">
                            
                                <td>
                                    <label class="custom-label" >
                                        <span>Employee Name</span>
                                    </label>
                                </td>
                                
                              

                            </tr>
                        </thead>
                        <tbody>
                            <tr class="hover-bg table-row" v-for="employee in paginatedData" :key="employee['employee_id']">
                                <td class="cursor-pointer trz_relative">
                                    {{ employee['name'] }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!--</div>-->
                <!--</div>-->
                <!-- list view ends here -->
                <!-- grid view starts here -->
                
                <!-- grid view ends here -->
                <div class="row py-2 no-margin" v-if="paginatedData.length > 0">
                    <div class="col-md-12 p-0 no-margin" v-if="paginatedData.length > 0">
                        <ul class="pagination b-pagination float-left mb-0 mt-1">
                            <li class="page-item disabled m-2">View</li>
                            <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options"
                                    @change="setFirstPage()"></b-form-select></li>
                            <li class="page-item disabled m-2">per page. Total {{ people }} records found.</li>
                        </ul>
                        <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage"
                            :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#"
                            first-number last-number></b-pagination-nav>
                    </div>

                </div>
                <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell text-center">
                    <span class="d-block text-center">{{ blankmsg }}</span>
                    <img v-if="showoverlay" v-bind:src="$api_url + '/images/download-loader.svg'" class="loader-logo"
                        width="100px" />
                </div>
            </div>

            <b-sidebar id="sidebar_right" title="Filter" right shadow>
                <employee-filter :key="sidebar_key" :company_options="company_options"
                    :search_by_filter="search_by_filter"
                    v-on:childToParent="filterList"></employee-filter> 
            </b-sidebar>

        </div>

    </b-overlay>
</template>


<script>
export default {

    data() {

        let sortOrders = {};

     
        return {

            columns: [],
            sortKey: 'name',
            sortOrders: sortOrders,
            pagination: { currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', nextbuttonstatus: 'true', prebuttonstatus: 'disabled' },
            search_by_filter: [],
            selected: [],
            sidebar_key: 0,
            selected_ids: [],
            showoverlay: true,
            blankmsg: 'Fetching data..',
            people: 0,
            search: '',
            length: 20,
            temp_length: 20,
            length_options: [],
            pagination: { currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', pages: 1 },
            status_flag: false,
            show_loader: false,
            tableStickyHeight: '',
            employees:[],
            default_column:['name'],
            company_options:[],
        }
    },
    methods: {


        filterList(value) {
            //console.log(value);
            this.resetPagination();
            if (value['reset'] == 1) {
                this.search_by_filter = value['search_by_filter'];
                $("#filter_button").click();

                //this.resetFlter();
            }
        },
      
        generateList: function () {

            let currentObj = this; 
                axios.get(this.$api_url+'/employee/employee-list' , {   
                    params: { 
                        
                    }
                }).then(function(response){
                    currentObj.showoverlay = false;
                    currentObj.employees = response.data.employee_data;
                    currentObj.company_options = response.data.options; 


                    if (currentObj.employees.length > 0) 
                    {
                        let cr = {};
                        cr['name'] = '';
                        cr['employee_code'] = '';
                        cr['jobposition_id'] = '';
                        cr['department_id'] = '';
                        cr['branch_id'] = '';

                        currentObj.search_by_filter = cr;
                        if (currentObj.employees.length == 0) {
                            currentObj.blankmsg = "Looks like there is no relevent data here.";
                            currentObj.show_loader = false;
                        }
                        else {
                            currentObj.tableStickyHeight = 'table-sticky-height';
                            currentObj.length_options = [{ value: 20, text: "20" },
                            { value: 50, text: "50" },
                            { value: 100, text: "100" }
                            ];
                            currentObj.people = currentObj.employees.length;

                        }

                    }
                    else {
                        currentObj.blankmsg = "Looks like there is no relevent data here.";
                        currentObj.show_loader = false;
                    }
            });


        },

    },
    created: function () {


  
        this.generateList();



        $(window).on('load', function (e) {
            setTimeout(function () {
                $('.div1').width($('table.employee-list-table').width());
                $('.div2').width($('table.employee-list-table').width());
                if ($('table.employee-list-table').width() > $('.wrapper1').width()) {
                    //alert($('table.employee-list-table').width());
                    $('.wrapper1').show();
                } else {
                    //alert('Its not bigger');
                    $('.wrapper1').hide();
                }
            }, 2000);
            $('.wrapper1').on('scroll', function (e) {
                $('.wrapper2').scrollLeft($('.wrapper1').scrollLeft());
            });
            $('.wrapper2').on('scroll', function (e) {
                $('.wrapper1').scrollLeft($('.wrapper2').scrollLeft());
            });

            $(document).on("click", ".trz-custom-dropdown .custom-switch input", function () {
                setTimeout(function () {
                    $('.div1').width($('table.employee-list-table').width());
                    $('.div2').width($('table.employee-list-table').width());
                    if ($('table.employee-list-table').width() > $('.wrapper1').width()) {
                        $('.wrapper1').show();
                    } else {
                        $('.wrapper1').hide();
                    }
                }, 500);
            });
        });

    },
    computed:
    {
        filteredData() {
  

            let filtered_list = this.employees;

            let search_by_custom_fields = this.search_by_filter;

            var search_terms = new Array();

            Object.keys(search_by_custom_fields).forEach(key => {

                if (search_by_custom_fields[key] != '' ) {
                    search_terms.push(`${key}:${search_by_custom_fields[key]}`);
                }
                else {
                    this.search_by_filter[key] = '';
                }
             

                /* issue

                if(this.status_flag)
                {
                    search_terms.push('status:Active');
                }

                */
            });

            //console.log(search_terms);

            if (search_terms.length > 0) {


                for (var i = 0; i < search_terms.length; i++) {
                    const term_to_search = search_terms[i].split(":");
                    let search_key = term_to_search[0];
                    let search_value = term_to_search[1];

                    if (search_key == 'status') {
                        filtered_list = filtered_list.filter((row) => { return Object.keys(row).some((key) => { return String(row[search_key]).toLowerCase().indexOf(search_value.toLowerCase()) == 0; }) });
                    }
                    else {
                        filtered_list = filtered_list.filter((row) => { return Object.keys(row).some((key) => { return String(row[search_key]).toLowerCase().indexOf(search_value.toLowerCase()) > -1; }) });
                    }

                }
                //console.log(filtered_list.length);

                this.pagination.currentPage = 1;
                if (filtered_list.length == 0) {

                    this.blankmsg = "Nothing found.";
                }
               
            }


            if (this.search) {



                filtered_list = filtered_list.filter((row) => {

                return Object.keys(row).some((key) => {

                    if (key == 'name' || key == 'employee_code' || key == 'email' || key == 'jobposition' || key == 'branch' || key == 'department') {
                        return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;
                    }

                })
                });

                if (filtered_list.length == 0)
                    this.blankmsg = "Nothing found.";
            }


            this.people = filtered_list.length;
            return filtered_list;
        },
        paginatedData() {
            return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        },
        
    }
}
</script>
<style>.employee-list-table tr td:last-child {
    padding-right: 20px;
}

.action_thead {
    text-align: right;
}

.trz_disable_box+label::before {
    background: #adb5bdab !important;
}

.trz_people_btn.trz_email {
    right: 0;
    top: -185px;
}

.trz_employee_draft_edit {
    position: absolute;
    left: 12px;
    top: 18px;
}

.trz_relative {
    position: relative;
}</style>
 